import CalculatorIcon from '../../../../../icons/calculator.svg';
import DollarTagIcon from '../../../../../icons/dollar-tag.svg';
import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg';
import DocumentIcon from '../../../../../icons/document.svg';

export default function PurchasingProcessData() {
    return {
        subtitle: "Click. Quote. Coverage.",
        image: "/product-landing/term/circle1.png",
        steps: [
            {
                title: "Determine Coverage Amount",
                icon: CalculatorIcon,
                paragraphs: [
                    "Calculate how much life insurance you may need.",
                ]
            },
            {
                title: "Personalize Quote",
                icon: DollarTagIcon,
                paragraphs: [
                    "Compare accurate pricing from top insurance companies based on your individual circumstances.",
                ]
            },
            {
                title: "Select and Apply",
                icon:HandSelectClickIcon,
                paragraphs: [
                    "Select the solution that best fits your needs and start the application.",
                ]
            },
            {
                title: "Approval and Payment",
                icon: DocumentIcon,
                paragraphs: [
                    "Receive application approval and make payment to activate coverage.",
                ]
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Term/PurchasingProcessData.js